import React from "react";
import MenuBar from "../components/MenuBar";
import SearchMenu from "../components/SearchMenu";
import Footer from "../components/Footer";

import Disclaimer from "../components/Disclaimer";

function Awards() {
  return (
  <>
  <SearchMenu/>
  <MenuBar/>
  <div className="py-8">

    <h1 className=" text-4xl text-center">Coming soon...</h1>

  </div>
  <Footer/>
  <Disclaimer/>
  </>
  )
}

export default Awards